import { render, staticRenderFns } from "./PopoverOrganizationProfile.vue?vue&type=template&id=2dba2114&scoped=true"
import script from "./PopoverOrganizationProfile.vue?vue&type=script&lang=js"
export * from "./PopoverOrganizationProfile.vue?vue&type=script&lang=js"
import style0 from "./PopoverOrganizationProfile.vue?vue&type=style&index=0&id=2dba2114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dba2114",
  null
  
)

export default component.exports